"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function qsp(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.625 12C8.625 10.1392 10.1392 8.625 12 8.625C13.8608 8.625 15.375 10.1392 15.375 12C15.375 12.4897 15.2678 12.954 15.0795 13.3748L12.852 11.1473L11.148 12.852L13.3755 15.0795C12.9431 15.2742 12.4742 15.3749 12 15.375C11.1052 15.374 10.2473 15.0181 9.61461 14.3854C8.98189 13.7527 8.62599 12.8948 8.625 12ZM17.4847 12C17.4857 10.9407 17.1782 9.90397 16.5997 9.0165L18.75 6.8655L17.1345 5.25L14.9835 7.401C14.124 6.84225 13.101 6.51525 12 6.51525C10.899 6.51525 9.876 6.84225 9.0165 7.40025L6.8655 5.25L5.25 6.8655L7.401 9.0165C6.84225 9.876 6.51525 10.899 6.51525 12C6.51525 13.101 6.843 14.124 7.401 14.9835L5.25 17.1345L6.8655 18.75L9.0165 16.599C9.876 17.1578 10.899 17.4847 12 17.4847C13.101 17.4847 14.124 17.1578 14.9835 16.599L17.1345 18.75L18.75 17.1345L16.599 14.9835C17.1778 14.0961 17.4855 13.0594 17.4847 12Z", fill: color }));
}
exports["default"] = qsp;
//# sourceMappingURL=qsp.js.map